import { render } from "./email.vue?vue&type=template&id=3e3b3920&scoped=true&ts=true"
import script from "./email.vue?vue&type=script&lang=ts"
export * from "./email.vue?vue&type=script&lang=ts"

import "./email.vue?vue&type=style&index=0&id=3e3b3920&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3b3920"]])

export default __exports__